module.exports = __webpack_public_path__ + "static/media/map-blur.af509914.jpg";